
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;
        let url = '';
        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }
        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }
        return url + relativeUrl;
      }
import __SNOWPACK_ENV__ from '../__snowpack__/env.js';
({ url: getAbsoluteUrl('_dist_/self_registration.js'), env: __SNOWPACK_ENV__ }).env = __SNOWPACK_ENV__;

import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import { Switch, Route, useParams, useRouteMatch, useHistory } from "../web_modules/react-router-dom.js";
import ContentLoader from "../web_modules/react-content-loader.js";
import { Helmet } from "../web_modules/react-helmet.js";
import { LoadingButton } from "../web_modules/@ticketbutler/toolbox.js";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import Turnstile, { useTurnstile } from "../web_modules/react-turnstile.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import { useLanguage, API_HOST, makeTbRequestHeaders, styles, FieldErrors, getFieldError, getInputForCustomQuestion, getThemedButton, RegisterRoute, sortBySortId, QuickPay, reportPaymentStepSuccessful, makeSearchParamString, cancelOrder } from "./app.js";
import { CheckoutContext, CheckoutDialog, useExistingReservationInParam } from "./checkout.js";
import ticketbutlerFavicon from "./assets/ticketbutler_favicon.png";
import { useScrollToError, Checkbox } from "./shared.js";
import { useTranslation } from "../web_modules/react-i18next.js";

var _StyledSpan = _styled("span").withConfig({
  displayName: "self_registration___StyledSpan",
  componentId: "py8oon-0"
})({
  textAlign: "center",
  display: "block"
});

var _StyledDiv = _styled("div").withConfig({
  displayName: "self_registration___StyledDiv",
  componentId: "py8oon-1"
})({
  maxWidth: 920,
  margin: "0 auto"
});

export function SelfRegistration({
  whitelabel,
  theme
}) {
  const {
    eventSlug,
    ticketTypeUuid
  } = useParams();
  const {
    path
  } = useRouteMatch();
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const {
    trigger: getEventDetails,
    lastResult,
    lastError
  } = useAsyncStatus(async function getEventAndTicket() {
    const req = await fetch([API_HOST, "events/title", eventSlug].join("/") + "/", {
      headers: makeTbRequestHeaders(language)
    });
    const res = await req.json();

    if (req.ok) {
      // Get the desired ticket from the event
      const event = res;
      const ticketType = event.ticket_types.find(ticketType => ticketType.uuid === ticketTypeUuid);

      if (ticketType) {
        return {
          event,
          ticketType
        };
      } else {
        throw Error("Ticket not found");
      }
    } else {
      throw Error();
    }
  });
  React.useEffect(function () {
    getEventDetails();
  }, [getEventDetails]);
  const {
    lastResult: existingReservation
  } = useExistingReservationInParam();
  return whitelabel && theme && lastResult ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, lastResult.event.title, " | ", whitelabel.name), whitelabel.favicon ? /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    href: whitelabel.favicon,
    type: "image/*"
  }) : /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    href: ticketbutlerFavicon,
    type: "image/*"
  })), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: path,
    component: function () {
      return /*#__PURE__*/React.createElement(SelfRegistrationForm, {
        event: lastResult.event,
        ticketType: lastResult.ticketType,
        theme: theme,
        whitelabel: whitelabel
      });
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: path + "/cancelled/"
  }, /*#__PURE__*/React.createElement(SelfRegistrationCancelled, {
    theme: theme,
    event: lastResult.event,
    ticketType: lastResult.ticketType,
    existingReservation: existingReservation
  })), /*#__PURE__*/React.createElement(Route, {
    path: path + "success",
    component: () => /*#__PURE__*/React.createElement(SelfRegistrationSuccess, {
      event: lastResult.event,
      ticketType: lastResult.ticketType,
      theme: theme,
      existingReservation: existingReservation
    })
  }))) : lastError ? /*#__PURE__*/React.createElement(_StyledSpan, null, t("event.connectingToTheEventError"), ".", " ", /*#__PURE__*/React.createElement("a", {
    href: window.location.href
  }, /*#__PURE__*/React.createElement("strong", null, t("event.tryAgain"))), ".") : /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 380 70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "5",
    ry: "5",
    width: "70",
    height: "70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "80",
    y: "17",
    rx: "4",
    ry: "4",
    width: "300",
    height: "13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "80",
    y: "40",
    rx: "3",
    ry: "3",
    width: "250",
    height: "10"
  })));
}

var _StyledH = _styled("h1").withConfig({
  displayName: "self_registration___StyledH",
  componentId: "py8oon-2"
})({
  textAlign: "center",
  fontSize: 20,
  fontWeight: "bold"
});

var _StyledH2 = _styled("h1").withConfig({
  displayName: "self_registration___StyledH2",
  componentId: "py8oon-3"
})({
  textAlign: "center",
  textTransform: "uppercase",
  fontSize: 20,
  fontWeight: "bold"
});

var _StyledHr = _styled("hr").withConfig({
  displayName: "self_registration___StyledHr",
  componentId: "py8oon-4"
})({
  margin: "25px 0"
});

var _StyledForm = _styled("form").withConfig({
  displayName: "self_registration___StyledForm",
  componentId: "py8oon-5"
})(["", ""], p => p._css);

var _StyledLabel = _styled("label").withConfig({
  displayName: "self_registration___StyledLabel",
  componentId: "py8oon-6"
})(["", ""], p => p._css2);

var _StyledInput = _styled("input").withConfig({
  displayName: "self_registration___StyledInput",
  componentId: "py8oon-7"
})(["", ""], p => p._css3);

var _StyledLabel2 = _styled("label").withConfig({
  displayName: "self_registration___StyledLabel2",
  componentId: "py8oon-8"
})(["", ""], p => p._css4);

var _StyledInput2 = _styled("input").withConfig({
  displayName: "self_registration___StyledInput2",
  componentId: "py8oon-9"
})(["", ""], p => p._css5);

var _StyledLabel3 = _styled("label").withConfig({
  displayName: "self_registration___StyledLabel3",
  componentId: "py8oon-10"
})(["", ""], p => p._css6);

var _StyledLabel4 = _styled("label").withConfig({
  displayName: "self_registration___StyledLabel4",
  componentId: "py8oon-11"
})(["", ""], p => p._css7);

var _StyledButton = _styled("button").withConfig({
  displayName: "self_registration___StyledButton",
  componentId: "py8oon-12"
})(["", ""], p => p._css8);

var _StyledP = _styled("p").withConfig({
  displayName: "self_registration___StyledP",
  componentId: "py8oon-13"
})({
  color: "red",
  textAlign: "center"
});

function SelfRegistrationForm({
  theme,
  whitelabel,
  event,
  ticketType
}) {
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const language = useLanguage();
  const {
    url
  } = useRouteMatch();
  const turnstile = useTurnstile();
  const [appearanceMode, setAppearanceMode] = React.useState("interaction-only");
  const [isCAPTCHAPassed, setIsCAPTCHAPassed] = React.useState(false);
  const showCAPTCHA = ticketType.is_free && !whitelabel.features.includes("disable-captcha");
  const {
    trigger: selfRegistration,
    status,
    lastResult: reservation,
    lastError,
    reset
  } = useAsyncStatus(async function selfRegistration(values) {
    const req = await fetch([API_HOST, "purchases/registration-at-the-door", event.uuid, ticketType.uuid, ""].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        event_uuid: event.uuid,
        ...values
      })
    });

    if (req.status !== 201) {
      if (showCAPTCHA) {
        turnstile.reset();
        setAppearanceMode("always");
      }

      const error = await req.json();
      throw error;
    } else {
      // Immediate payment is not required, show success
      if (ticketType.is_free === true) {
        history.push(url + "/success/" + makeSearchParamString());
      } else {
        // Use the default payment gateway
        const res = await req.json();
        return res;
      }
    }
  });
  useScrollToError(Boolean(lastError));
  const [checkoutContext, setCheckoutContext] = React.useState({
    warnBeforeExit: true,
    checkoutComplete: false
  });
  React.useEffect(function () {
    // Reset checkout status on clear
    if (checkoutContext.checkoutComplete && !reservation) {
      setCheckoutContext(s => ({ ...s,
        warnBeforeExit: true,
        checkoutComplete: false
      }));
    }
  }, [checkoutContext.checkoutComplete, reservation]);

  if (event && whitelabel) {
    const questionsForTicketType = event.ticket_types_questions.reduce(function (acc, questionGroup) {
      if ( // Question group is for all ticket types
      !questionGroup.ticket_type_name || // Question group is for this ticket type only
      questionGroup.ticket_type_name === ticketType.title) {
        acc.push(...questionGroup.questions);
      }

      return acc;
    }, []);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%",
        maxWidth: 520,
        margin: "0 auto",
        marginTop: 120
      }
    }, /*#__PURE__*/React.createElement(_StyledH, null, t("event.registrationFor").toUpperCase() + " " + event.title.toUpperCase()), /*#__PURE__*/React.createElement(_StyledH2, null, ticketType.title + " " + t("event.ticket").toLowerCase()), /*#__PURE__*/React.createElement(_StyledHr, null), /*#__PURE__*/React.createElement(_StyledForm, {
      onSubmit: function (e) {
        e.preventDefault();
        const values = serialize(e.target, {
          hash: true,
          empty: true
        });
        selfRegistration(values);
      },
      _css: [{
        display: "flex",
        flexDirection: "column"
      }, styles.form]
    }, /*#__PURE__*/React.createElement(_StyledLabel, {
      _css2: styles.inputLabel
    }, /*#__PURE__*/React.createElement("span", null, t("event.firstName"), " *"), /*#__PURE__*/React.createElement(_StyledInput, {
      name: "first_name",
      required: true,
      _css3: styles.input
    }), /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(lastError, "first_name")
    })), /*#__PURE__*/React.createElement(_StyledLabel2, {
      _css4: styles.inputLabel
    }, /*#__PURE__*/React.createElement("span", null, t("event.lastName"), " *"), /*#__PURE__*/React.createElement(_StyledInput2, {
      name: "last_name",
      required: true,
      _css5: styles.input
    }), /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(lastError, "last_name")
    })), event.purchase_questions && event.purchase_questions.questions.sort(sortBySortId).map(function (question) {
      // Hide question if all the choice limits have been reached
      if (question.variation === "SELECT_MULTIPLE" || question.variation === "SELECT") {
        if (question.choices.every(choice => {
          return choice.limit ? choice.limit <= choice.used : false;
        })) {
          return null;
        }
      }

      if (question.variation === "ADDRESS") {
        return null;
      }

      return /*#__PURE__*/React.createElement(_StyledLabel3, {
        key: question.uuid,
        _css6: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, question.heading, question.required && " *"), getInputForCustomQuestion(question), /*#__PURE__*/React.createElement(FieldErrors, {
        errors: getFieldError(lastError, question.uuid)
      }));
    }), questionsForTicketType.length > 0 && questionsForTicketType.map(function (question) {
      // In the self registration we already ask for the attendees name, so we do not need to show the ticket type question for NAME.
      if (question.variation !== "NAME" && question.variation !== "NAME_FIRST_LAST") {
        // Hide question if all the choice limits have been reached
        if (question.variation === "SELECT_MULTIPLE" || question.variation === "SELECT") {
          if (question.choices.every(choice => {
            return choice.limit ? choice.limit <= choice.used : false;
          })) {
            return null;
          }
        }

        return /*#__PURE__*/React.createElement(_StyledLabel4, {
          key: question.uuid,
          _css7: styles.inputLabel
        }, /*#__PURE__*/React.createElement("span", null, question.heading, question.required && " *"), getInputForCustomQuestion(question, ""), /*#__PURE__*/React.createElement(FieldErrors, {
          errors: getFieldError(lastError, question.uuid)
        }));
      }
    }), /*#__PURE__*/React.createElement(Checkbox, {
      required: true,
      name: "terms_and_conditions_agreed",
      label: /*#__PURE__*/React.createElement("span", null, t("event.iAgreeTo"), " ", /*#__PURE__*/React.createElement("a", {
        href: `/${language}/tandc/`,
        target: "_blank",
        rel: "noopener noreferrer"
      }, t("event.termsAndConditions").toLowerCase()), ".*")
    }), /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(lastError, "terms_and_conditions_agreed")
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        margin: "0 auto"
      }
    }, showCAPTCHA && /*#__PURE__*/React.createElement(Turnstile, {
      sitekey: ({ url: getAbsoluteUrl('_dist_/self_registration.js'), env: __SNOWPACK_ENV__ }).env.SNOWPACK_PUBLIC_TURNSTILE_SITE_KEY,
      appearance: appearanceMode,
      theme: "light",
      fixedSize: true,
      onVerify: () => {
        setIsCAPTCHAPassed(true);
      }
    })), /*#__PURE__*/React.createElement(LoadingButton, {
      loading: status === AsyncStates.Pending,
      success: status === AsyncStates.Success
    }, /*#__PURE__*/React.createElement(_StyledButton, {
      disabled: showCAPTCHA && turnstile && !isCAPTCHAPassed,
      type: "submit",
      _css8: [getThemedButton(theme), {
        margin: "0 auto",
        marginTop: 15,
        backgroundColor: showCAPTCHA && turnstile && !isCAPTCHAPassed ? "lightgrey" : theme.colour_primary
      }]
    }, t("event.checkout"))), /*#__PURE__*/React.createElement(React.Fragment, null, lastError instanceof Error ? /*#__PURE__*/React.createElement(_StyledP, {
      className: "errorMessage"
    }, t("event.errorTryAgain"), ".") : /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(lastError, "non_field_errors")
    })))), /*#__PURE__*/React.createElement(CheckoutContext.Provider, {
      value: { ...checkoutContext,
        setCheckoutContext
      }
    }, /*#__PURE__*/React.createElement(CheckoutDialog, {
      isOpen: reservation ? true : false,
      purchaseUUID: reservation ? reservation.purchase.uuid : undefined,
      whitelabel: whitelabel
    }, reservation &&
    /*#__PURE__*/
    // Only render payment routes if we we have the info for them
    React.createElement(RegisterRoute, {
      path: `/${language}/r/` + [event.title_url, "register", ticketType.uuid].join("/")
    }, /*#__PURE__*/React.createElement(QuickPay, {
      theme: theme,
      urlParameters: "?self_registration=true",
      purchaseUUID: reservation.purchase.uuid,
      whitelabel: whitelabel
    })))));
  } else return /*#__PURE__*/React.createElement("div", null, "Something is wrong. Please check the URL and try again");
}

var _StyledButton2 = _styled("button").withConfig({
  displayName: "self_registration___StyledButton2",
  componentId: "py8oon-14"
})(["", ""], p => p._css9);

function SelfRegistrationSuccess({
  theme,
  event,
  ticketType,
  existingReservation
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation(); // We need to tell the Tickbutler API that the user is now back from
  // or has completed the payment step, so the state can be updated to WAITING.

  React.useEffect(function () {
    if (existingReservation && existingReservation.purchase.state === "PAYGATEWAY") {
      // TODO: We could add a loading state and re-try here if there's
      // an error with this request?
      reportPaymentStepSuccessful(language, existingReservation.purchase.uuid);
    }
  }, [existingReservation, language]);
  React.useEffect(() => {
    setTimeout(() => {
      window.location.assign(ticketType.uuid ? `/${language}/r/${event.title_url}/register/${ticketType.uuid}/` : `/${language}/r/${event.title_url}/register/`);
    }, 5000);
  }, [event.title_url, language, ticketType.uuid]);
  return event && theme && /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      maxWidth: 520,
      margin: "0 auto",
      marginTop: 120
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "auto",
      height: "50vh",
      textAlign: "center",
      marginTop: "50%",
      maxWidth: window.innerWidth <= 520 ? "75%" : 800
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      color: theme.colour_primary,
      fontSize: window.innerWidth <= 600 ? 20 : 24,
      fontWeight: 400,
      letterSpacing: 2,
      marginTop: 50
    }
  }, t("event.registrationSuccessful").toUpperCase() + "!"), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: window.innerWidth <= 600 ? 30 : 60,
      marginBottom: 35
    }
  }, t("event.goToCheckinCounter")), /*#__PURE__*/React.createElement("a", {
    style: {
      textDecoration: "none"
    },
    href: ticketType.uuid ? `/${language}/r/${event.title_url}/register/${ticketType.uuid}` : `/${language}/r/${event.title_url}/register/`
  }, /*#__PURE__*/React.createElement(_StyledButton2, {
    _css9: [getThemedButton(theme), {
      margin: "0 auto",
      maxWidth: 250
    }]
  }, t("event.newRegistration")))));
}

var _StyledButton3 = _styled("button").withConfig({
  displayName: "self_registration___StyledButton3",
  componentId: "py8oon-15"
})(["", ""], p => p._css10);

export function SelfRegistrationCancelled({
  theme,
  event,
  ticketType,
  existingReservation
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  React.useEffect(function () {
    if (existingReservation && existingReservation.purchase.uuid) {
      // Cancel the payment with Ticketbutler
      cancelOrder(existingReservation.purchase.uuid, language);
    }
  }, [existingReservation, language]);
  React.useEffect(() => {
    setTimeout(() => {
      window.location.assign(ticketType.uuid ? `/${language}/r/${event.title_url}/register/${ticketType.uuid}/` : `/${language}/r/${event.title_url}/register/`);
    }, 5000);
  }, [event.title_url, language, ticketType.uuid]);
  return event && theme && /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      maxWidth: 520,
      margin: "0 auto",
      marginTop: 120
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "auto",
      height: "50vh",
      textAlign: "center",
      marginTop: "50%",
      maxWidth: window.innerWidth <= 520 ? "75%" : 800
    }
  }, /*#__PURE__*/React.createElement("h1", null, t("event.yourRegistrationWasCancelled"), "."), /*#__PURE__*/React.createElement("a", {
    style: {
      textDecoration: "none"
    },
    href: ticketType.uuid ? `/${language}/r/${event.title_url}/register/${ticketType.uuid}` : `/${language}/r/${event.title_url}/register/`
  }, /*#__PURE__*/React.createElement(_StyledButton3, {
    _css10: [getThemedButton(theme), {
      margin: "0 auto",
      maxWidth: 250
    }]
  }, t("event.backToCheckinCounter")))));
}